import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";

// Components
import ShareWithOptionItem from "./ShareWithOptionItem";
import Text from "../../components/Text";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2)
  },
  content: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
    margin: 0,
    listStyle: "none"
  },
  label: {
    textTransform: "capitalize"
  },
  placeholder: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4, 0)
  }
}));

const ShareWithOptionList = ({ options }) => {
  const classes = useStyles();

  return options.length > 0 ? (
    <div className={classes.root}>
      <Text
        type="body2"
        text="common.prompts.availableOptions"
        className={classes.label}
      />
      <ul className={classes.content}>
        {options.map(item => (
          <ShareWithOptionItem key={item.id} item={item} />
        ))}
      </ul>
    </div>
  ) : (
    <div className={classes.placeholder}>
      <Text text="casesPage.search.emptyText" type="body2" />
    </div>
  );
};

ShareWithOptionList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({}))
};

ShareWithOptionList.defaultProps = {
  options: []
};

export default ShareWithOptionList;
